import { IconProps } from "../../../types/style";

const ReplaceBoxs = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1868 5.18945L17.8428 7.30223L21.4621 5.19865"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.8428 11.0409V7.29297"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.9793 3.13138L14.7746 4.35309C14.2786 4.62867 13.8652 5.3268 13.8652 5.89634V8.22963C13.8652 8.79916 14.2694 9.4973 14.7746 9.77288L16.9793 10.9946C17.4478 11.261 18.2194 11.261 18.6971 10.9946L20.9017 9.77288C21.3978 9.4973 21.8112 8.79916 21.8112 8.22963V5.89634C21.8112 5.3268 21.407 4.62867 20.9017 4.35309L18.6971 3.13138C18.2286 2.87417 17.457 2.87417 16.9793 3.13138Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.76074 15.2949L7.4076 17.4077L11.0361 15.3041"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.40747 21.1464V17.3984"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.55303 13.2369L4.34839 14.4586C3.85234 14.7341 3.43896 15.4323 3.43896 16.0018V18.3351C3.43896 18.9046 3.84316 19.6028 4.34839 19.8783L6.55303 21.1001C7.02152 21.3665 7.79315 21.3665 8.27082 21.1001L10.4755 19.8783C10.9715 19.6028 11.3849 18.9046 11.3849 18.3351V16.0018C11.3849 15.4323 10.9807 14.7341 10.4755 14.4586L8.27082 13.2369C7.79315 12.9796 7.02152 12.9796 6.55303 13.2369Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M15.2019 22C14.9479 22 14.7128 21.8588 14.5906 21.6423C14.4683 21.4259 14.4683 21.1529 14.6 20.9365L15.5875 19.2894C15.785 18.9506 16.2176 18.847 16.5562 19.0447C16.8947 19.2423 16.9982 19.6753 16.8007 20.0141L16.5467 20.4377C19.1425 19.8259 21.0893 17.4918 21.0893 14.7059C21.0893 14.32 21.409 14 21.7946 14C22.1802 14 22.5 14.32 22.5 14.7059C22.4906 18.7247 19.2177 22 15.2019 22Z"
          fill={color}
        />
        <path
          opacity="0.4"
          d="M3.20619 10C2.82014 10 2.5 9.68 2.5 9.29412C2.5 5.27529 5.77673 2 9.79731 2C10.0515 2 10.2869 2.14118 10.4093 2.35765C10.5317 2.57412 10.5317 2.84706 10.3999 3.06353L9.41126 4.71059C9.21352 5.04942 8.78039 5.15296 8.44142 4.95531C8.10245 4.75766 7.99888 4.32469 8.19661 3.98587L8.45085 3.56233C5.85206 4.17409 3.90297 6.50824 3.90297 9.29412C3.91239 9.68 3.59224 10 3.20619 10Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default ReplaceBoxs;
